<div class="vehicles-list-container">
  <div class="vehicles-header">
    <div class="header-left" (click)="toggleExpand()">
      <h3>Vehicles</h3>
    </div>
    <div class="header-right">
      <div class="select-all-container" (click)="toggleSelectAll(); $event.stopPropagation()">
        <div class="checkbox" [class.checked]="isAllSelected()">
          <svg *ngIf="isAllSelected()" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M11.6667 3.5L5.25 9.91667L2.33333 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <span class="select-all-label">Select All</span>
      </div>
      <button class="expand-btn" [class.expanded]="isExpanded" (click)="toggleExpand()">
        <img [src]="imgConstants.EXPAND_ARROW" alt="expand-arrow" />
      </button>
    </div>
  </div>

  <div class="vehicles-list" *ngIf="isExpanded">
    <div 
      *ngFor="let vehicle of vehicles" 
      class="vehicle-card"
      [class.selected]="vehicle.selected"
      (click)="toggleVehicleSelection(vehicle)"
    >
      <div class="color-bar" [style.background-color]="vehicle.color"></div>
      <div class="vehicle-card-content">

      <div class="checkbox-container">
        <div class="checkbox" [class.checked]="vehicle.selected">
          <svg *ngIf="vehicle.selected" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M11.6667 3.5L5.25 9.91667L2.33333 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>

      <div class="vehicle-info">
        <div class="vehicle-header">
          <div class="details">
          <span class="vehicle-registration">{{ vehicle.etsVehicle.registration }}</span>
          <span class="vehicle-type">{{ vehicle.etsVehicle.cabType.name }}</span>
        </div>
        <div class="vehicle-vendor">{{ vehicle.etsVehicle.vendor.vendorName }}</div>
        <div class="seats-info">
          <div class="capacity d-flex-row">
            <img [src]="imgConstants.CAPACITY" alt="capacity" />
            <span>{{ vehicle.vehicleCapacity }}</span>
          </div>
          <div class="boarded d-flex-row">
            <img [src]="imgConstants.BOARDED" alt="boarded" />
            <span>{{ vehicle.boardedCount }}</span>
          </div>
          <div class="spare-seats d-flex-row">
            <img [src]="imgConstants.SPARE_SEATS" alt="spare-seats" />
            <span>{{ vehicle.spareSeat }}</span>
          </div>
        </div>
      </div>

        
        <div class="vehicle-stats">
          <div class="time-info">
            <span class="label">Start</span>
            <span class="value">{{ vehicle.startTime  || 'N/A'}}</span>
          </div>
          <div class="time-info">
            <span class="label">End</span>
            <span class="value">{{ vehicle.endTime || 'N/A' }}</span>
          </div>
        </div>

      </div>
        
      </div>
    </div>


    <div *ngIf="vehicles.length === 0" class="empty-state">
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
        <rect x="8" y="16" width="32" height="20" rx="2" stroke="#ccc" stroke-width="2"/>
        <circle cx="16" cy="32" r="3" stroke="#ccc" stroke-width="2"/>
        <circle cx="32" cy="32" r="3" stroke="#ccc" stroke-width="2"/>
        <path d="M8 24H40" stroke="#ccc" stroke-width="2"/>
      </svg>
      <p>No vehicles available</p>
    </div>
  </div>
</div>
